<template>
  <div class="h5">
    <ul v-if="screenWidth > 850" class="h5ContentList">
      <li v-for="(item, i) in h5list" :key="i">
          <!-- 二维码 -->
          <div class="qucode">
            <img :src="address + item.code" alt />
          </div>
          <!-- 图片 -->
          <div class="pic">
            <img :src="address + item.img" alt />
          </div>
          <!-- 标题 -->
          <div class="title">{{item.content}}</div>
          <!-- 描述 -->
          <div class="describe">{{item.content}}</div>
          <!-- 日期 -->
          <div class="time">{{item.itemTime | dateFormat}}</div>
      </li>
    </ul>
    <ul v-else class="h5ContentList">
      <li v-for="(item, i) in h5list" :key="i">
        <a target="_blank" :href="item.url">
          <!-- 二维码 -->
          <div class="qucode">
            <img :src="address + item.code" alt />
          </div>
          <!-- 图片 -->
          <div class="pic">
            <img :src="address + item.img" alt />
          </div>
          <!-- 标题 -->
          <div class="title">{{item.content}}</div>
          <!-- 描述 -->
          <div class="describe">{{item.content}}</div>
          <!-- 日期 -->
          <div class="time">{{item.itemTime | dateFormat}}</div>
        </a>
      </li>
    </ul>
    <!-- 分页 -->
    <div class="pagingList">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.size"
        :current-page="page"
        background
        layout="pager"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 查询参数对象
      queryInfo: {
        query: '',
        page: 0,
        size: 15,
        type: 10000,
        sort: 'sort,asc'
      },
      // 列表
      h5list: {},
      // 当前页
      page: 1,
      // 总条数
      total: 0,
      address: 'http://uploads.i-mineral.cn/',
      screenWidth: document.body.clientWidth
    }
  },
  created() {
    this.getH5List()
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  methods: {
    async getH5List() {
      const { data: res } = await this.$http.get('/api/itemInfo', {
        params: this.queryInfo
      })
      if (res.content === null) {
        return this.$message.error('获取h5列表失败！')
      }
      this.h5list = res.content
      this.total = res.totalElements
    },
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage - 1
      this.getH5List()
      this.page = newPage
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 850px) {
  .h5ContentList {
    width: 100%;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 849px) {
  .h5ContentList {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
}

.h5ContentList li {
  width: 200px;
  height: 300px;
  border: 1px solid rgb(220, 220, 220);
  margin: 8px;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
}
.h5ContentList li .pic {
  width: 100%;
  height: 150px;
  overflow: hidden;
  position: relative;
}
.h5ContentList li .pic img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  animation: width121_100 1s;
}
.h5ContentList li:hover .pic img {
  animation: width100_120 1s forwards;
}
.h5ContentList li .qucode {
  width: 200%;
  height: 150px;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 50%;
  top: 0%;
  transform: translate(-50%, 0);
  display: none;
  z-index: 300;
}
.h5ContentList li:hover .qucode {
  display: block;
}
.h5ContentList li .qucode img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
}
.h5ContentList li .title {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  font-weight: 600;
}
.h5ContentList li .describe {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  color: rgb(115, 115, 115);
  font-size: 14px;
}
.h5ContentList li .time {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  color: rgb(115, 115, 115);
  font-size: 14px;
}
/* 分页 */
.pagingList {
  width: 100%;
  max-width: 1100px;
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
</style>
